import { useLocation } from "react-router-dom";
import { titleForPath } from "../../../router/navigation";
import { openCommandPalette } from "../commandPaletteBus";

const envColor = {
  prod: "bg-red-100 text-red-700 border-red-200",
  stage: "bg-amber-100 text-amber-700 border-amber-200",
  dev: "bg-emerald-100 text-emerald-700 border-emerald-200",
};

const ENV = ((import.meta.env.VITE_APP_ENV as "prod" | "stage" | "dev" | undefined) ?? "prod");
const BUILD = import.meta.env.VITE_APP_BUILD ?? "frontend";

export function TopBar() {
  const { pathname } = useLocation();
  const title = titleForPath(pathname);

  return (
    <header className="h-11 shrink-0 bg-white border-b border-slate-200 flex items-center px-5 gap-3">
      <h1 className="text-sm font-semibold text-slate-800 mr-auto">{title}</h1>
      <button
        onClick={openCommandPalette}
        className="flex items-center gap-2 text-xs text-slate-500 border border-slate-200 rounded-md px-2.5 py-1 hover:bg-slate-50 cursor-pointer transition-colors"
        title="Search (⌘K)"
      >
        <i className="ri-search-line" />
        <span className="hidden sm:inline">Search…</span>
        <kbd className="font-mono text-[10px] bg-slate-100 px-1 rounded">⌘K</kbd>
      </button>
      <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded border uppercase tracking-wide ${envColor[ENV]}`}>{ENV}</span>
      <span className="text-[10px] font-mono text-slate-400 hidden lg:block">{BUILD}</span>
      <button
        onClick={() => window.location.reload()}
        className="w-7 h-7 flex items-center justify-center rounded hover:bg-slate-100 text-slate-500 cursor-pointer transition-colors"
        title="Refresh"
      >
        <i className="ri-refresh-line text-sm" />
      </button>
    </header>
  );
}
